export default class Wine
{
  constructor(names, descriptions, consumptions, temperatures, castes, stages, datasheets, nutritionalSheets, prizes, types, photo, year, position) 
  {
    // {} instead of array to support stringify
    this.names = names;
    this.descriptions = descriptions;
    this.consumptions = consumptions;
    this.temperatures = temperatures;
    this.castes = castes;
    this.stages = stages;
    this.datasheets = datasheets;
    this.nutritionalSheets = nutritionalSheets;

    this.prizes = prizes;
    this.types = types;

    this.photo = photo;
    this.year = year;
    this.position = position;
  }    

  isValid()
  {
    var result = true;

    for (const [key, value] of Object.entries(this.names)) { if(!value) { result = false; break; }; } // Names
    if(result) for (const [key, value] of Object.entries(this.descriptions)) { if(!value) { result = false; break; }; } // Descriptions
    if(result) for (const [key, value] of Object.entries(this.consumptions)) { if(!value) { result = false; break; }; } // Consumptions
    if(result) for (const [key, value] of Object.entries(this.temperatures)) { if(!value) { result = false; break; }; } // Temperatures
    if(result) for (const [key, value] of Object.entries(this.castes)) { if(!value) { result = false; break; }; } // Castes
    if(result) for (const [key, value] of Object.entries(this.stages)) { if(!value) { result = false; break; }; } // Stages

    if(result) result = this.types.length && this.photo && this.year;

    // prizes, datasheets and nutritionalSheets are optional
    
    return result;
  }
}